import { WE_SPIN_ACCOUNT_TEXT_KEYS, WE_SPIN_RAFFLE_TEXT_KEYS } from './we-spin-text-keys.js';

import { WE_SPIN_EVENT_TAG_ALL_TEXT_KEYS } from './we-spin-event-tags.js';

export const WE_SPIN_DASHBOARD_CREATE_EVENT_AS_TESTER = 'WE_SPIN_DASHBOARD_CREATE_EVENT_AS_TESTER';
export const WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD = 'WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD';
export const WE_SPIN_DASHBOARD_TAB_ITEM_LIVE_DASHBOARD = 'WE_SPIN_DASHBOARD_TAB_ITEM_LIVE_DASHBOARD';
export const WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM = 'WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM';
export const WE_SPIN_DASHBOARD_TAB_ITEM_CALENDAR = 'WE_SPIN_DASHBOARD_TAB_ITEM_CALENDAR';
export const WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS = 'WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS';
export const WE_SPIN_DASHBOARD_TAB_ITEM_SEARCH = 'WE_SPIN_DASHBOARD_TAB_ITEM_SEARCH';
export const WE_SPIN_DASHBOARD_TAB_ITEM_CHAT = 'WE_SPIN_DASHBOARD_TAB_ITEM_CHAT';
export const WE_SPIN_DASHBOARD_CHAT_POPOUT = 'WE_SPIN_DASHBOARD_CHAT_POPOUT';

export const WE_SPIN_DASHBOARD_TAB_ITEM_TEXTKEYS = [
	WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD,
	WE_SPIN_DASHBOARD_TAB_ITEM_LIVE_DASHBOARD,
	WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM,
	WE_SPIN_DASHBOARD_TAB_ITEM_CALENDAR,
	WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS,
	WE_SPIN_DASHBOARD_TAB_ITEM_SEARCH,
	WE_SPIN_DASHBOARD_TAB_ITEM_CHAT,
	WE_SPIN_DASHBOARD_CHAT_POPOUT
];
export const WE_SPIN_DASHBOARD_NOTIFICATION_IMAGE_UPLOADED = 'WE_SPIN_DASHBOARD_NOTIFICATION_IMAGE_UPLOADED';

export const WE_SPIN_WALLET_TEXT_KEYS = [
	'WE_SPIN_WALLET_BLOCKED_TITLE',
	'WE_SPIN_WALLET_BLOCKED',
	'WE_SPIN_WALLET_BLOCKED_DESC',
	'WE_SPIN_GO_TO_DASHBOARD_BUTTON'
];
export const WE_SPIN_DASHBOARD_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_BUTTON_SCHEDULE_STREAM',
	'WE_SPIN_DASHBOARD_BUTTON_SAVE_CHANGES',
	'WE_SPIN_DASHBOARD_BUTTON_CONFIRM',
	'WE_SPIN_DASHBOARD_BUTTON_STOP_SESSION',
	'WE_SPIN_DASHBOARD_BUTTON_START_SESSION',
	'WE_SPIN_DASHBOARD_BUTTON_BACK_TO_DASHBOARD',
	'WE_SPIN_DASHBOARD_EDIT_SESSION_LABEL',
	WE_SPIN_DASHBOARD_NOTIFICATION_IMAGE_UPLOADED,
	WE_SPIN_DASHBOARD_CREATE_EVENT_AS_TESTER,
	'WE_SPIN_DASHBOARD_BUTTON_STOP_EVENT',
	'WE_SPIN_DASHBOARD_NO_EVENTS_SCHEDULED',
	'WE_SPIN_DASHBOARD_NO_EVENTS_PASSED',
	'WE_SPIN_DASHBOARD_NO_EVENTS_SCHEDULED_DESC',
	'WE_SPIN_DASHBOARD_NO_EVENTS_PASSED_DESC',
	'WE_SPIN_DASHBOARD_BUTTON_ADD_EVENT',
	'WE_SPIN_DASHBOARD_CREATION_SUCCESS_TITLE',
	'WE_SPIN_DASHBOARD_CREATION_SUCCESS_CONTENT_PRIVATE',
	'WE_SPIN_DASHBOARD_COPY_LINK_DONE',
	'WE_SPIN_DASHBOARD_BUTTON_COPY_LINK',
	'WE_SPIN_DASHBOARD_BUTTON_SELECT_GAMES'
];

export const WE_SPIN_DASHBOARD_STREAM_FIELD_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_STREAM_FIELD_NAME_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_NAME_MAX_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_NAME_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_DESCR_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_DESCR_MAX_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_DESCR_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_URL_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_URL_MAX_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_URL_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_START_DATE_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_START_DATE_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_START_TIME_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_START_TIME_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_LENGTH_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_LENGTH_MIN_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_LENGTH_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_BALANCE_CAP_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_BALANCE_CAP_MIN_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_BALANCE_CAP_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_LANGUAGE_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_LANGUAGE_MAX_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_LANGUAGE_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GAME_PROVIDER_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GAME_PROVIDER_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GAME_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GAME_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GAME_HEADER_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_EVENT_TAG_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GROUP_WHEN',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GROUP_OPTIONAL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_STREAMER_IMAGE_DESC',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_EVENT_NAME',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_GROUP_BUY_IN',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_TIPS_TITLE',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_IMAGE_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_BET_SIZE_RANGE_LABEL',
	'WE_SPIN_DASHBOARD_STREAM_FIELD_BET_SIZE_RANGE_ERROR_VALIDATION_MSG'
];

export const WE_SPIN_DASHBOARD_CREATE_PROFILE_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_CREATE_PROFILE_SUCCESS_HEADER',
	'WE_SPIN_DASHBOARD_CREATE_PROFILE_SUCCESS_TEXT',
	'WE_SPIN_DASHBOARD_CREATE_PROFILE_ADD_STREAM_BUTTON',
	'WE_SPIN_DASHBOARD_CREATE_PROFILE_CREATE_BUTTON',
	'WE_SPIN_DASHBOARD_CREATE_PROFILE_CREATE_HEADER'
];

export const WE_SPIN_DASHBOARD_LIVE_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_LIVE_END_STREAM_TITLE',
	'WE_SPIN_DASHBOARD_LIVE_END_STREAM_TEXT',
	'WE_SPIN_DASHBOARD_LIVE_END_STREAM_YES_BUTTON',
	'WE_SPIN_DASHBOARD_LIVE_END_STREAM_NO_BUTTON',
	'WE_SPIN_DASHBOARD_LIVE_COUNTDOWN_LABEL',
	'WE_SPIN_DASHBOARD_LIVE_NET_RESULT_LABEL',
	'WE_SPIN_DASHBOARD_LIVE_WE_SPIN_BALANCE_LABEL',
	'WE_SPIN_DASHBOARD_LIVE_PLAYERS_LABEL'
];

export const WE_SPIN_DASHBOARD_LIVE_STREAM_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_LIVE_STREAM_STATS_TITLE',
	'WE_SPIN_DASHBOARD_LIVE_STREAM_STATS_ALL_DONE',
	'WE_SPIN_DASHBOARD_LIVE_STREAM_STATS_TEXT',
	'WE_SPIN_DASHBOARD_LIVE_STREAM_STATS_TOTAL_PLAYERS',
	'WE_SPIN_DASHBOARD_LIVE_STREAM_STATS_EVENT_RESULTS'
];

export const WE_SPIN_DASHBOARD_SCHEDULED_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_TITLE',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_TEXT',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_YES_BUTTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_NO_BUTTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_STREAM_FOR',
	'WE_SPIN_DASHBOARD_SCHEDULED_STREAM_ENDED',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_BUTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_VIEW_DETAILS_BUTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_EDIT_STREAM_BUTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_CANCEL_BUTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_UPCOMING_TITLE',
	'WE_SPIN_DASHBOARD_SCHEDULED_PAST_TITLE',
	'WE_SPIN_DASHBOARD_SCHEDULED_ITEM_BALANCE',
	'WE_SPIN_DASHBOARD_SCHEDULED_ITEM_PLAYERS',
	'WE_SPIN_DASHBOARD_SCHEDULED_ITEM_STATE',
	'WE_SPIN_DASHBOARD_SCHEDULED_ITEM_RESULT',
	'WE_SPIN_DASHBOARD_SCHEDULED_BUY_IN_TO_EVENT_BUTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_ITEM_PAYOUT',
	'WE_SPIN_DASHBOARD_SCHEDULED_ITEM_ENDED',
	'WE_SPIN_DASHBOARD_SCHEDULED_UPCOMING_LIST_TITLE',
	'WE_SPIN_DASHBOARD_SCHEDULED_TODAY',
	'WE_SPIN_DASHBOARD_SCHEDULED_TOMORROW'
];

export const WE_SPIN_DASHBOARD_START_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_START_SWITCH_BALANCE_TITLE',
	'WE_SPIN_DASHBOARD_START_SWITCH_BALANCE_TEXT',
	'WE_SPIN_DASHBOARD_START_SWITCH_YES_BUTTON',
	'WE_SPIN_DASHBOARD_START_SWITCH_NO_BUTTON',
	'WE_SPIN_DASHBOARD_START_SWITCH_PRE_SESSION_BUTTON',
	'WE_SPIN_DASHBOARD_START_SWITCH_RUNNING_SESSION_BUTTON',
	'WE_SPIN_DASHBOARD_START_SWITCH_REG_CAPTION',
	'WE_SPIN_DASHBOARD_START_SWITCH_PENDING_START_CAPTION',
	'WE_SPIN_DASHBOARD_START_SWITCH_RUNNING_CAPTION',
	'WE_SPIN_DASHBOARD_START_SWITCH_GO_LIVE',
	'WE_SPIN_DASHBOARD_START_SWITCH_LIVESTREAM',
	'WE_SPIN_DASHBOARD_STOP_SWITCH_LIVESTREAM'
];

export const WE_SPIN_DASHBOARD_EDIT_PROFILE_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_NAME',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_NAME_MAX_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_NAME_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_DESCR',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_DESCR_MAX_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_DESCR_REQ_VALIDATION_MSG',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_BG_URL',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_BG_URL_INFO',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_PROFILE_URL',
	'WE_SPIN_DASHBOARD_EDIT_PROFILE_STREAMER_BG_URL_INFO_CAPTION',
	...WE_SPIN_DASHBOARD_STREAM_FIELD_TEXT_KEYS
];

export const WE_SPIN_BONUS_BOOST_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_BONUS_BOOST_TITLE',
	'WE_SPIN_DASHBOARD_BONUS_BOOST_LABEL',
	'WE_SPIN_DASHBOARD_BONUS_BOOST_BUTTON'
];

export const WE_SPIN_DASHBOARD_POPUPS_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_LIVE_END_SESSION_TITLE',
	'WE_SPIN_DASHBOARD_LIVE_END_SESSION_TEXT',
	'WE_SPIN_DASHBOARD_LIVE_END_EVENT_TITLE',
	'WE_SPIN_DASHBOARD_LIVE_END_EVENT_TEXT',
	'WE_SPIN_DASHBOARD_LIVE_END_YES_BUTTON',
	'WE_SPIN_DASHBOARD_LIVE_END_NO_BUTTON',
	'WE_SPIN_DASHBOARD_LIVE_START_EVENT_TITLE',
	'WE_SPIN_DASHBOARD_LIVE_START_EVENT_TEXT',
	'WE_SPIN_DASHBOARD_LIVE_START_EVENT_BALANCE',
	'WE_SPIN_DASHBOARD_LIVE_END_SESSION_AND_EVENT_TEXT',
	'WE_SPIN_DASHBOARD_LIVE_BROADCAST_ON_TEXT'
];

export const WE_SPIN_DASHBOARD_NO_SCHEDULED_EVENTS_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_NO_EVENT_SCHEDULED_TITLE',
	'WE_SPIN_DASHBOARD_NO_EVENT_SCHEDULED_SUBTITLE',
	'WE_SPIN_DASHBOARD_NO_EVENT_SCHEDULED_BUTTON'
];

export const WE_SPIN_DASHBOARD_EVENT_DETAIL_VIEW_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_LIVE_START_EVENT_BALANCE',
	'WE_SPIN_DASHBOARD_LIVE_START_EVENT_CURRENT_BALANCE',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_EVENT_TYPE',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_BOOST_TYPE',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_BOOST_AMOUNT',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_PLAYERS',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_EDIT_EVENT',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_EDIT',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_AVAILABLE_IN',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_TOGGLE_EVENT_NO_GAME',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_STREAM_URL',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_STREAM_URL_COPY',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_BET_SIZE_RANGE_LABEL',
	'WE_SPIN_DASHBOARD_LIVE_EVENT_GAMES_LABEL'
];

export const WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_INFO_TEXT',
	'WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_LABEL_SELECTED',
	'WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_TITLE',
	'WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_LABEL_SELECTED_GAMES',
	'WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_LABEL_BUTTON_DONE',
	'WE_SPIN_DASHBOARD_MULTI_GAME_SELECT_SEARCH_PLACEHOLDER'
];

export const WE_SPIN_DASHBOARD_TWITCH_AUTH_TEXT_KEYS = [
	'WE_SPIN_TWITCH_AUTH_HEADER',
	'WE_SPIN_TWITCH_AUTH_DESCRIPTION',
	'WE_SPIN_TWITCH_AUTH_ACTION',
	'WE_SPIN_TWITCH_AUTH_SUCCESS_RESULT_HEADER',
	'WE_SPIN_TWITCH_AUTH_SUCCESS_RESULT_DESCRIPTION',
	'WE_SPIN_TWITCH_AUTH_SUCCESS_RESULT_ACTION',
	'WE_SPIN_TWITCH_AUTH_FAILED_RESULT_HEADER',
	'WE_SPIN_TWITCH_AUTH_FAILED_RESULT_DESCRIPTION',
	'WE_SPIN_TWITCH_AUTH_FAILED_RESULT_ACTION'
];

export const WE_SPIN_DASHBOARD_ALL_TEXT_KEYS = [
	...new Set([
		...WE_SPIN_DASHBOARD_STREAM_FIELD_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_TAB_ITEM_TEXTKEYS,
		...WE_SPIN_DASHBOARD_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_CREATE_PROFILE_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_LIVE_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_SCHEDULED_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_START_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_EDIT_PROFILE_TEXT_KEYS,
		...WE_SPIN_ACCOUNT_TEXT_KEYS,
		...WE_SPIN_EVENT_TAG_ALL_TEXT_KEYS,
		...WE_SPIN_BONUS_BOOST_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_POPUPS_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_NO_SCHEDULED_EVENTS_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_EVENT_DETAIL_VIEW_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_LIVE_STREAM_TEXT_KEYS,
		...WE_SPIN_RAFFLE_TEXT_KEYS,
		...WE_SPIN_DASHBOARD_TWITCH_AUTH_TEXT_KEYS
	])
];
